import React from 'react';
import { IRegistroCircularizacao } from '../interfaces/ICircularizacao';

interface Props {
  registro: IRegistroCircularizacao;
  onFechar: () => void;
}

// Seção 3.3/4/12.2 — consultar a justificativa de seleção (e as demais, quando existirem) sem
// perder a justificativa original, mesmo após alterações posteriores.
const JustificativaModal: React.FC<Props> = ({ registro, onFechar }) => (
  <div className='circ-modal-backdrop' onMouseDown={(e) => e.target === e.currentTarget && onFechar()}>
    <div className='circ-modal'>
      <div className='circ-modal-header'>
        <h4>Justificativas — {registro.razaoSocialExibicao}</h4>
        <button type='button' className='btn btn-sm btn-icon btn-light' aria-label='Fechar' onClick={onFechar}>
          <i className='bi bi-x-lg' />
        </button>
      </div>
      <div className='circ-modal-body'>
        <div className='circ-secao-expandida'>
          <div className='circ-secao-expandida-titulo'>Justificativa Original da Seleção</div>
          <p style={{ fontSize: 13.5 }}>{registro.justificativaOriginal}</p>
        </div>

        {registro.justificativaInclusaoManual && (
          <div className='circ-secao-expandida'>
            <div className='circ-secao-expandida-titulo'>Justificativa da Inclusão Manual</div>
            <p style={{ fontSize: 13.5 }}>{registro.justificativaInclusaoManual}</p>
          </div>
        )}

        {registro.justificativaAlteracao && (
          <div className='circ-secao-expandida'>
            <div className='circ-secao-expandida-titulo'>Justificativa da Última Alteração</div>
            <p style={{ fontSize: 13.5 }}>{registro.justificativaAlteracao}</p>
          </div>
        )}

        {registro.justificativaExclusao && (
          <div className='circ-secao-expandida'>
            <div className='circ-secao-expandida-titulo'>Justificativa da Exclusão</div>
            <p style={{ fontSize: 13.5 }}>{registro.justificativaExclusao}</p>
          </div>
        )}
      </div>
      <div className='circ-modal-footer'>
        <button type='button' className='btn btn-sm btn-primary' onClick={onFechar}>
          Fechar
        </button>
      </div>
    </div>
  </div>
);

export default JustificativaModal;
